import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GenericTable from '../../components/GenericTable/GenericTable';
import SearchBar from '../../components/SearchBar/SearchBar';
import Pagination from '../../components/Pagination/Pagination';
import { FaTimesCircle } from 'react-icons/fa';
import Cookies from 'js-cookie';


function HomePage() {
    const [pools, setPools] = useState([]);
    const [redirects, setRedirects] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [currentRedirectPage, setCurrentRedirectPage] = useState(1);
    const [domainsPerPage] = useState(25);
    const [newPoolName, setNewPoolName] = useState('');
    const [isAddingPool, setIsAddingPool] = useState(false);
    const [fromValue, setFromValue] = useState('');
    const [toValue, setToValue] = useState('');
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [poolToDelete, setPoolToDelete] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPools = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pool`, {
                credentials: "include"
            });
            if (response.status === 401) {
                Cookies.remove('session-id');
                navigate('/login');
            } else {
                const body = await response.json();
                setPools(body.data);
    
                if (body.data.length > 0) {
                    setFromValue(body.data[0].title);
                    setToValue(body.data[0].title);
                }
            }
        };
        fetchPools();

        const fetchRedirects = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/redirect`, {
                credentials: "include",
            });

            if (response.status === 401) {
                Cookies.remove('session-id');
                navigate('/login');
            }

            const body = await response.json();
            setRedirects(body.data);
        };
        fetchRedirects();
    }, []);

    const handleDeletePool = (title) => {
        setPoolToDelete(title);
        setIsConfirmationOpen(true);
    };

    const handleConfirmDelete = async (deleteDomains) => {
        if (poolToDelete) {
            console.log('Deleting pool:', poolToDelete, deleteDomains);
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pool`, {
                method: "DELETE",
                credentials: "include",
                headers: {  'Content-Type': 'application/json' },
                body: JSON.stringify({
                    title: poolToDelete,
                    deleteDomains: deleteDomains 
                })
            });

            if (response.status === 401) {
                Cookies.remove('session-id');
                navigate('/login');
            }   

            if (response.ok) {
                setPools(prevPools => prevPools.filter(pool => pool.title !== poolToDelete));
                
                if (deleteDomains) {
                    localStorage.removeItem(`${poolToDelete}-domains`);
                    setRedirects(prevRedirects =>
                        prevRedirects.filter(redirect =>
                            redirect.source !== poolToDelete && redirect.target !== poolToDelete
                        )
                    );
                }
            }
        }

        setIsConfirmationOpen(false);
        setPoolToDelete(null);
    };

    const handleCancelDelete = () => {
        setIsConfirmationOpen(false);
        setPoolToDelete(null);
    };

    const redirectHeaders = ['Source', 'Target', ''];
    const redirectRows = redirects.map(redirect => ({
        source: redirect.source,
        target: redirect.target,
        action: (
            <div className="flex items-center justify-center">
                <FaTimesCircle className="text-red-500" onClick={() => handleDeleteRedirect(redirect.source, redirect.target)} />
            </div>
        )
    }));

    const filteredRedirectRows = redirectRows.filter(row =>
        (row.source && row.source.toLowerCase().includes(searchQuery)) ||
        (row.target && row.target.toLowerCase().includes(searchQuery))
    );

    const totalRedirectPages = Math.ceil(filteredRedirectRows.length / domainsPerPage);
    const redirectStartIndex = (currentRedirectPage - 1) * domainsPerPage;
    const redirectCurrentRows = filteredRedirectRows.slice(redirectStartIndex, redirectStartIndex + domainsPerPage);

    const handleRedirectPageChange = (page) => {
        setCurrentRedirectPage(page);
    };

    const headers = ["Pool", ""];
    const rows = pools.map(pool => ({
        title: pool.title,
        action: (
            <div className="flex self-center justify-center">
                <FaTimesCircle className="text-red-500" onClick={() => handleDeletePool(pool.title)} />
            </div>
        )
    }));

    const filteredRows = rows.filter(row =>
        (row.title && row.title.toLowerCase().includes(searchQuery))
    );

    const totalPages = Math.ceil(filteredRows.length / domainsPerPage);
    const startIndex = (currentPage - 1) * domainsPerPage;
    const currentRows = filteredRows.slice(startIndex, startIndex + domainsPerPage);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // const handleDeletePool = async (title) => {
    //     const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pool?title=${title}`, {
    //         method: "DELETE",
    //         credentials: "include"
    //     });

    //     if (response.status === 401) {
    //         Cookies.remove('session-id');
    //         navigate('/login');
    //     }

    //     if (response.ok) {
    //         setPools(prevPools =>
    //             prevPools.filter(pool => pool.title !== title)
    //         );

    //         setRedirects(prevRedirects =>
    //             prevRedirects.filter(redirect =>
    //                 redirect.source !== title && redirect.target !== title
    //             )
    //         );
    //     }
    // };

    const handleDeleteRedirect = async (source, target) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/redirect`, {
            method: "DELETE",
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                source: source,
                target: target
            })
        });

        if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        }

        if (response.ok) {
            setRedirects(prevRedirects =>
                prevRedirects.filter(redirect =>
                    !(redirect.source === source && redirect.target === target)
                )
            );
        }
    };

    const handleAddPool = async () => {
        if (!newPoolName) return;

        if (pools.some(pool => pool.title.toLowerCase() === newPoolName.toLowerCase())) {
            alert('Pool already exists.');
            setNewPoolName('');
            return;
        }

        setIsAddingPool(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pool?title=${newPoolName}`, {
                method: 'POST',
                credentials: "include"
            });

            if (response.status === 401) {
                Cookies.remove('session-id');
                navigate('/login');
            }

            if (response.ok) {
                const data = await response.json();
                setPools(prevPools => [...prevPools, data]);
                if (!toValue) setToValue(data.title);
                if (!fromValue) setFromValue(data.title);
            }
        } catch (error) {
            console.error('Error adding pool:', error);
        } finally {
            setNewPoolName('');
            setIsAddingPool(false);
        }
    };

    const handleAddRedirect = async () => {
        console.log('to', toValue, 'from', fromValue);
        if (!fromValue || !toValue || fromValue === toValue) {
            alert('Incorrect values for redirect!');
            return;
        }

        const existingRedirect = redirectRows.find(row => row.target === fromValue && row.source === toValue);
        if (existingRedirect) {
            alert('Block creation loop rule.');
            return;
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/redirect`, {
            method: "POST",
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                source: fromValue,
                target: toValue,
            })
        });

        if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        }

        if (response.ok) {
            const body = await response.json();
            setRedirects(prevRedirects => [...prevRedirects, body]);
        }
    };

    const poolLink = (row) => {
        navigate(`/pool/${row.title}`);
    };

    const truncateString = (str, length) => {
        return str.length > length ? str.slice(0, length) + '...' : str;
    };

    return (
        <div className='p-4'>
            <div className="w-full max-w-xl my-5 mx-auto">
                <SearchBar placeholder="Search by pool name.." onSearch={setSearchQuery} />
            </div>
            <div className="flex flex-row justify-between gap-32">
                <div className='min-w-1/4'>
                    <h2 className="text-2xl font-bold mb-4">Pools</h2>
                    <div className="flex items-center justify-between gap-4 mb-4 max-w">
                        <input
                            type="text"
                            value={newPoolName}
                            onChange={(e) => setNewPoolName(e.target.value)}
                            placeholder="Enter pool name"
                            className="w-full max-w-sm px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <button
                            onClick={handleAddPool}
                            disabled={isAddingPool}
                            className={`max-w-xs px-4 py-2 font-semibold text-white bg-blue-500 rounded-lg shadow-md transition duration-200 hover:bg-blue-600 focus:outline-none ${
                                isAddingPool ? 'cursor-not-allowed opacity-50' : ''
                            }`}
                        >
                            Add
                        </button>
                    </div>

                    {currentRows.length === 0 ? (
                        <p className="my-10 text-xl font-semibold text-gray-500 text-center">No pools found.</p>
                    ) : (
                        <div>
                            <GenericTable headers={headers} data={currentRows} className="w-full" rowLink={poolLink} groupName={'pools'} />
                            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
                        </div>  
                    )}
                    
                </div>

                <div className='min-w-3/4'>
                    <h2 className="text-2xl font-bold mb-4">Redirects</h2>
                    <div className="flex items-center justify-between gap-4 mb-4 max-w">
                        <div className="flex items-center gap-4">
                            <h4>From:</h4>
                            <select
                                value={fromValue}
                                onChange={(e) => setFromValue(e.target.value)}
                                className="block w-full min-w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
                            >
                                {pools.map((pool) => (
                                    <option key={pool.id} value={pool.title}>
                                        {truncateString(pool.title, 20)}
                                    </option>
                                ))}
                            </select>
                            <h4>To:</h4>
                            <select
                                value={toValue}
                                onChange={(e) => setToValue(e.target.value)}
                                className="block w-full min-w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
                            >
                                {pools.map((pool) => (
                                    <option key={pool.id} value={pool.title}>
                                        {truncateString(pool.title, 20)}
                                    </option>
                                ))}
                            </select>
                            <button
                                onClick={handleAddRedirect}
                                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                Add
                            </button>
                        </div>
                    </div>

                    {redirectCurrentRows.length === 0 ? (
                        <p className="my-10 text-xl font-semibold text-gray-500 text-center">No redirects found.</p>
                    ) : (
                        <div>
                            <GenericTable headers={redirectHeaders} data={redirectCurrentRows} className="w-full" groupName={'redirects'} />
                            <Pagination currentPage={currentRedirectPage} totalPages={totalRedirectPages} onPageChange={handleRedirectPageChange} />
                        </div>
                    )}
                </div>
            </div>

            {isConfirmationOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg border">
                        <h3 className="text-lg font-semibold mb-4">Are you sure you want to delete pool: <bold>{poolToDelete}</bold> ?</h3>
                        <p className="mb-4 text-sm">Do you also want to delete the domains in this pool?</p>
                        <div className="flex gap-4 text-sm">
                            <button onClick={() => handleConfirmDelete(true)} className="bg-red-500 text-white px-4 py-2 rounded-md">
                                Delete with domains
                            </button>
                            <button onClick={() => handleConfirmDelete(false)} className="bg-red-500 text-white px-4 py-2 rounded-md">
                                Delete, but keep domains
                            </button>
                            <button onClick={handleCancelDelete} className="bg-gray-200 text-black px-4 py-2 rounded-md">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default HomePage;
